import React from 'react';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import handOne from './images/handOne.png';
import handTwo from './images/handTwo.png';
import handThree from './images/handThree.png';
import phf from './images/phf-logo.jpeg';
import powerToChange from './images/ptc-logo.png';
import theHive from './images/the-hive-logo.jpeg';
import lloyds from './images/lbssep.png';
import unltd from './images/unltd-logo.png';
import fif from './images/fif-logo.png';
import hiFive from './images/hi5.png';
import isoCert from './images/iso9001.png';
import iso27001 from './images/iso27001.png';
import classNames from 'classnames';
import css from './AboutPage.module.css';

const AboutPage = () => {
  // prettier-ignore
  return (
    <StaticPage
      title="About Us"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description:
          'Find out who Signalise Co-operative is, who are our members and the services we provide',
        name: 'About page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <div className={css.contentWrapper}>
            <h1 className={css.pageTitle}>About us and our users</h1>
            <div className={css.contentContainer}>
            <div className={css.contentSide}>
              <img src={hiFive} alt="Two Signalise hands happy" className={css.hand} />
            </div>

            <div className={css.contentMain}>
              <section id="about" className={css.section}>
                <div className="aboutContent">
                  <p>
                    Signalise is a multi-stakeholder co-operative which was established in October
                    2019. As a cooperative, our communities – deaf people and interpreters – are our
                    members. Through many years of professional, real-world experience, we've
                    reached a collective conclusion: the current system of booking British Sign
                    Language Interpreters does not work. We are here to change that!
                  </p>
                  <p>
                    Signalise is a unique service, co-designed by our members - Deaf people and
                    communication professionals.
                  </p>
                  <p>
                    We welcome involvement from health and social care providers and commissioners
                    who need to purchase services and organisations involved in the Deaf community.
                  </p>
                  <p>
                    Only by working together can we meet the needs of all our user groups - Deaf
                    people, professionals and interpreters.
                  </p>
                </div>
              </section>
              {/* END ABOUT */}

              {/* BEGIN SIGNALISE USERS */}
              <section id="users" className={css.section}>
                <h2>Our Users</h2>
                <div className="usersContent">
                  <p>
                    There are three user groups involved in Deaf people's access to services. Deaf
                    people, professionals and the interpreters who facilitate this communication.
                  </p>
                  <p>
                    We have co-designed our service with each of our user groups, running focus
                    groups and via an online survey.{' '}
                    <a href="https://signalise.coop/resources.html#our-report">
                      Read our report
                      <em> Signing the right path </em>here.
                    </a>
                  </p>
                </div>
                <ul className={css.signaliseUsers}>
                  <li className={css.user}>
                    <img src={handOne} className={css.hand} alt="hand smiling"></img>
                    <p className={css.userText}>
                      The British Deaf Association says there are up to 87,000 Deaf people who use
                      British Sign Language in the UK as their first or preferred language.
                    </p>
                  </li>
                  <li className={css.user}>
                    <img src={handTwo} className={css.hand} alt="hand gazing"></img>
                    <p className={css.userText}>
                      There are only 1,300 British Sign Language(BSL)/English Interpreters
                      in the UK with 50 on Merseyside.
                    </p>
                  </li>
                  <li className={css.user}>
                    <img src={handThree} className={css.hand} alt="hand running"></img>
                    <p className={css.userText}>
                      Frontline staff and organisations across all sectors that need to provide
                      services to Deaf people.
                    </p>
                  </li>
                </ul>
              </section>

              <section className={css.section}>
                <h2>Our Supporters</h2>
                <p>
                  We have raised £65,000 so far via grants and community fundraising. Our
                  Crowdfunder campaign in October 2020 raised a whopping £8,605 with 255 supporters
                  in 28 days (with an initial target of £5,000!). A huge thank you to all of our
                  supporters! Our community Share Offer raised £328,250 (10% over target) and we have
                  been joined by over 200 new supporters. We look forward to working with you all
                  soon!
                </p>

                <ul className={css.orgLogos}>
                  <li className={css.orgLogo}>
                    <img src={theHive} alt="The Hive logo" className={css.logoExpanded} />
                  </li>
                  <li className={css.orgLogo}>
                    <img
                      src={lloyds}
                      alt="Lloyds Bank Social Entrepreneurs Programme logo"
                      className={css.logoExpanded}
                    />
                  </li>
                  <li className={css.orgLogo}>
                    <img
                      src={phf}
                      alt="Paul Hamlyn Foundation logo"
                      className={css.logoExpanded} />
                  </li>
                  <li className={css.orgLogo}>
                    <img
                      src={powerToChange}
                      alt="Power to Change logo"
                      className={css.logoStandard}
                    />
                  </li>
                  <li className={css.orgLogo}>
                    <img src={unltd} alt="UnLtd logo" className={css.logoStandard} />
                  </li>
                  <li className={css.orgLogo}>
                    <img
                      src={fif}
                      alt="Liverpool City Future Innovation Fund logo"
                      className={css.logoStandard}
                    />
                  </li>
                </ul>
              </section>
              <section className={css.section}>
                <h2>Our accreditations</h2>
                <h3>ISO Standards</h3>
                <ul className={css.accreditationLogos}>
                  <li className={classNames(css.accreditationLogo, css.vert)}>
                    <img
                      src={isoCert}
                      alt="ISO Certification"
                      className={css.logoTall}/>
          
                      <div className={css.accreditationDates}>
                        <span>Start date: 20/05/2022</span>
                        <span>Expiry date: 19/05/2025</span>
                      </div>
                  </li>
                  <li className={classNames(css.accreditationLogo, css.vert)}>
                    <img
                      src={iso27001}
                      alt="ISO Certification"
                      className={css.logoTall}/>
                    <div className={css.accreditationDates}>
                      <span>Start date: 19/07/2024</span>
                      <span>Expiry date: 18/07/2025</span>
                    </div>
                  </li>
                  </ul>

                <h3>Cyber Essentials</h3>
                  <ul className={css.accreditationLogos}>
                  <li className={css.iframe}>
                  <iframe
                    src="https://registry.blockmarktech.com/certificates/99fa9701-0f51-4d18-a6e0-bf4247e4e05e/widget/?tooltip_position=corner&theme=transparent"
                    className={css.bm}
                  />
                  </li>
                  <li className={css.iframe}>
                    <iframe
                    src="https://registry.blockmarktech.com/certificates/efafd8d7-576d-4eba-8d44-7f25f753dbd1/widget/?tooltip_position=corner&theme=transparent"
                    className={css.bm}
                  />
                  </li>
                </ul>
              </section>
            </div>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default AboutPage;
